'use strict';

var isIe9 = require('@braintree/browser-detection/is-ie9');

module.exports = {
  isIe9: isIe9
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/lib/browser-detection.js
// module id = 783
// module chunks = 0